export const dateToLocaleString = (
  date: Date | string | number,
  withTime = false,
  onlyTime = false,
  withOutYear = false
): string => {
  const _date = new Date(date)
  if (isNaN(_date.getTime())) {
    return ''
  }
  const dateStr = _date.toLocaleDateString('ru-Ru', {
    day: 'numeric',
    month: 'long',
    // year: 'numeric'
  })
  const time = _date.toLocaleTimeString('ru-Ru', {
    hour: 'numeric',
    minute: 'numeric',
  })

  if (withOutYear) {
    return dateStr
  }

  const year = _date.getFullYear()

  const formatDate = `${dateStr} ${year}`
  if (onlyTime) {
    return time
  }

  if (withTime) {
    return `${formatDate}, ${time}`
  }
  return formatDate
}
